import { IHotel } from '@entities/hotel';
import { ChildServiceFilterItem } from '../types';

export default function (hotel: IHotel, childServiceFilterIds: ChildServiceFilterItem['id'][] = []): boolean {
    return childServiceFilterIds.every((id) => hotel.childServices.includes(id));
}
